export { useWidthFromAnchor } from '../internal/use-width-from-anchor';
